export enum OnboardingStep {
  WELCOME = 0,
  EXPLAINER = 1,
  PROFILE_EDIT = 2,
  INTERESTS = 3,
  FOLLOW_SUGGESTIONS = 4,
  VERIFICATION = 5,
  COMPLETION_SCREEN = 6,
}
